import { render, staticRenderFns } from "./ResetUserPassword.vue?vue&type=template&id=aea67e5e&scoped=true&lang=html&"
import script from "./ResetUserPassword.vue?vue&type=script&lang=js&"
export * from "./ResetUserPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetUserPassword.vue?vue&type=style&index=0&id=aea67e5e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea67e5e",
  null
  
)

export default component.exports